import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import Bank from "./Bank";
import Card from "./Card";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TopSec() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Outlet />
      <Box sx={{ borderColor: "divider" }}>
        <Tabs
          value={value}
          textColor="#1E222B"
          TabIndicatorProps={{ style: { background: "#00BC67" } }}
          indicatorColor="secondary"
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {/* <Tab label={<p className='text-[16px] font-[500]'>Banks</p>}
            {...a11yProps(0)} />
          <Tab label="Cards" {...a11yProps(1)} /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Bank />
      </TabPanel>
      {/* <TabPanel value={value} index={1}>
        <Card />
      </TabPanel> */}
    </Box>
  );
}
